import { Card, CardBody, Col, Toast, ToastBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { StackingToast } from "../../../../Constant";
import { STACKING_TOAST, STACKING_TOAST_LIST } from "../../../../Data/Bonus Ui/Toasts";
import { useState } from "react";
import { Btn } from "../../../../AbstractElements";
import { Bell } from "react-feather";
import { CommonToast } from "../Common/CommonToast";

const StackingToasts = () => {
  const [open, setopen] = useState(true);

  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={StackingToast} span={STACKING_TOAST} />
        <CardBody className="toast-rtl">
          <div className="toast-container position-static">
            <Toast isOpen={open}>
              <div className="toast-header">
                <Bell className="toast-icons toast-primary" />
                <strong className="me-auto">Boho theme</strong>
                <small className="txt-danger">just now</small>
                <Btn className="btn-close p-0" onClick={() => setopen(false)}></Btn>
              </div>
              <ToastBody className="toast-dark">Hello, I'm a web-designer.</ToastBody>
            </Toast>
            {STACKING_TOAST_LIST.map((data, index) => (
              <CommonToast item={data} key={index} />
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default StackingToasts;
